
import {Typography} from "antd";
import "../../Styles/styles-Chat.css";

function ChatbotIntroOverlay(props) {

    const className=`intro-overlay ${props.show ? "is-visible" : "is-hidden"}`

    return (
        <div className={`chat-messages-wrapper-overlay ${className}`}>
            <div style={{
                width: "60%", 
                textAlign: "left",
                justifySelf: "center",
                }}>
            <Typography.Text strong style={{fontSize: '30px'}}>Hi, I'm Whistle AI.</Typography.Text><br/>
            <Typography.Text style={{fontSize: '14px'}}>
                I help analyze your GPS, Testing, Force Plate, Nutrition, Cognition, Wellness, and Treatment data in real time — delivering clear, actionable answers in seconds. Filter by players, positions, groups, or compare any two time windows to understand what's happening and what's changing — so your team can <b>Get Ready to Perform.</b>
            </Typography.Text>
            <Typography.Text strong style={{fontSize: '15px', margin: '4px 0', display: 'block'}}>Here's how we can turn data into decisions:</Typography.Text>
            
            <Typography.Text strong>GPS & On Field Training</Typography.Text><br/>
            <Typography.Text italic className="chat-messages-wrapper-overlay-bullet-detail">"Which game had the most accelerations in 2025?"</Typography.Text><br/>
            <Typography.Text italic className="chat-messages-wrapper-overlay-bullet-detail">"Rank all my players by top speed for January 2026"</Typography.Text><br/>

            <Typography.Text strong>Testing & Force Plates</Typography.Text><br/>
            <Typography.Text italic className="chat-messages-wrapper-overlay-bullet-detail">"What was John Doe's max peak velocity for power clean lifts in December 2025?"</Typography.Text><br/>
            <Typography.Text italic className="chat-messages-wrapper-overlay-bullet-detail">"Who had the highest CMJ - mRSI last year?"</Typography.Text><br/>

            <Typography.Text strong>Wellness & Recovery</Typography.Text><br/>
            <Typography.Text italic className="chat-messages-wrapper-overlay-bullet-detail">"Who had the lowest fatigue levels this year?"</Typography.Text><br/>
            <Typography.Text italic className="chat-messages-wrapper-overlay-bullet-detail">"Who had the most manual therapy treatments in december 2025?"</Typography.Text><br/>

            <Typography.Text strong>Comparisons & Summaries</Typography.Text><br/>
            <Typography.Text italic className="chat-messages-wrapper-overlay-bullet-detail">"Compare the Average Back Squat Power for John Doe and Jane Smith this year"</Typography.Text><br/>
            <Typography.Text italic className="chat-messages-wrapper-overlay-bullet-detail">"Compare this year to last year for number of injuries"</Typography.Text><br/>

            <Typography.Text style={{display: 'block', marginTop: '8px', fontSize: '14px'}}>
                <b>Pro tip:</b> The clearer the question, the more actionable the answer. <br/>
                Tell me what you want to understand and I'll surface what matters.
            </Typography.Text> 
            </div>

        </div>
    )
}

export default ChatbotIntroOverlay;
